import React, { FC } from 'react';
import EngagementCenterContent from './EngagementCenterContent';

export const EngagementCenter: FC = () => (
  <div className="flex flex-col flex-1 overflow-hidden w-full px-6 pt-10 mx-auto bg-white font-effra">
    <h1 className="text-4xl font-effra">Engagement Center</h1>
    <p className="font-effra max-w-4xl mt-7 text-lg text-default">
      The Engagement Center provides free on-demand access to customizable resources to communicate to members about the
      benefits they receive through Teladoc Health. Engage using flyers, emails, direct mail, digital banners, video,
      and more!
    </p>
    <EngagementCenterContent />
  </div>
);
